var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWithdrawals = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 20 19.999",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Withdrawals",
    transform: "translate(-106.037 -585.07)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48386",
    "data-name": "Path 48386",
    d: "M126.036,587.259v-.311a1.955,1.955,0,0,0-2.024-1.878H108.065a1.953,1.953,0,0,0-2.026,1.877h0v.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48535",
    "data-name": "Path 48535",
    d: "M106.039,588.477v9.806a2.244,2.244,0,0,0,2.024,2.406h3.2a2.719,2.719,0,0,1,.538-1.013,2.437,2.437,0,0,1,1.842-.862,2.393,2.393,0,0,1,.513.056v-3.5a2.513,2.513,0,1,1,5.019,0v3.361a2.322,2.322,0,0,1,.514-.057,2.433,2.433,0,0,1,1.844.868,2.734,2.734,0,0,1,.569,1.144h1.907a2.242,2.242,0,0,0,2.024-2.4v-9.806Zm6.527,5.177a.682.682,0,0,1-.624.727h-3.658a.682.682,0,0,1-.626-.727v-2.161a.683.683,0,0,1,.626-.726h3.658a.684.684,0,0,1,.624.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48537",
    "data-name": "Path 48537",
    d: "M118.86,598.68a.716.716,0,0,0-1.012-.058.645.645,0,0,0-.059.058l-1.427,1.539v-5.976a.761.761,0,1,0-1.517-.123.842.842,0,0,0,0,.123v6.089l-1.426-1.538a.719.719,0,0,0-1.015-.057.764.764,0,0,0-.057.057.863.863,0,0,0,0,1.157l2.668,2.878a.717.717,0,0,0,1.012.06.846.846,0,0,0,.06-.06l2.773-2.992A.863.863,0,0,0,118.86,598.68Z",
    transform: "translate(1.102 2)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWithdrawals);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_withdrawals.73b173e6afa7671636304a78f1b76675.svg";